import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';

import axios from 'axios';
import Context from './context/Context';

// axios.defaults.baseURL = 'https://apiback.facevalo.fr/api/';

axios.defaults.baseURL = 'http://localhost:8000/api/';

ReactDOM.render(
  <React.StrictMode>
    <Context>
      <App />
    </Context>
  </React.StrictMode>,
  document.getElementById('root')
);